export abstract class Event {
}